/*eslint-disable*/
import React, { useMemo, useState } from "react";
import StepChart from "../../lib/components/StepChart/index_highcharts";
import LineBarComposedChart from "../../lib/components/LineBarComposedChart";
import useStepChartReducer from "./hooks/useStepChartReducer";
// import ChargerDetails from "../charger_details/ChargerDetails";
import FilterBar from "../../lib/components/Filterbar/Filterbar";
import ChargerDisplay from "../../lib/components/ChargerDisplay";
import { useGlobalFilters } from "../../lib/context/GlobalFilterProvider";
// import { getRange } from "../../lib/utils/utility";
// import { DEFAULT_TIME_RANGE } from "../../lib/utils/constants";
import useBarChartReducer from "./hooks/useBarChartReducer";
import useEnergyConsumptionReducer from "./hooks/useEnergyConsumptionHook/useEnergyConsumptionReducer";
import SlideOutPanel from "../ocpp_messages/SlideOutPanel";

export default function ChargerMetrics() {
  const { serialNumber, dateRange: globalDateRange, siteId } = useGlobalFilters();
  const [dateRange, setDateRange] = useState(globalDateRange);
  const chartFilters = useMemo(
    () => ({ chargerId: serialNumber, timeRange: dateRange, siteId }),
    [serialNumber, dateRange, siteId]
  );
  const { status } = useStepChartReducer(chartFilters);
  const { matrix } = useBarChartReducer(chartFilters);
  const energyConsumption = useEnergyConsumptionReducer(chartFilters);
  const [openChargerDetailsSlideout, setOpenChargerDetailsSlideout] = useState(false);

  const handleDateChange = range => {
    setDateRange(range);
  };

  const handleOnRefresh = () => {};

  return (
    <div className="w-full h-screen overflow-hidden p-8">
      <h1 className="text-2xl font-bold mb-2">EV Charger Metrics</h1>
      <FilterBar
        onDateChange={handleDateChange}
        handleOnRefresh={handleOnRefresh}
        chargerDetails={true}
        openChargerDetailsSlideout={() => setOpenChargerDetailsSlideout(true)}
      />
      <ChargerDisplay serialNumber={serialNumber} onClick={() => setOpenChargerDetailsSlideout(true)} />
      <div className="flex gap-8 items-start h-[calc(100vh-200px)]">
        <div className="flex-1 flex flex-col gap-5" style={{ flexBasis: "100%", maxWidth: "100%", height: "100%" }}>
          <LineBarComposedChart
            data={matrix?.data}
            energyConsumptionData={energyConsumption?.state?.data}
            loading={matrix.isLoading && energyConsumption?.state?.isLoading}
          />
          <StepChart data={status?.data} loading={status.isLoading} dateRange={dateRange} />
        </div>
        {/* <div style={{ flexBasis: "25%", maxWidth: "25%", height: "100%" }} className="overflow-y-auto">
          <ChargerDetails />
        </div> */}
      </div>
      {openChargerDetailsSlideout && (
        <SlideOutPanel open={openChargerDetailsSlideout} onClose={() => setOpenChargerDetailsSlideout(false)} />
      )}
    </div>
  );
}
